import combineUrlAndParams from './combineUrlAndParams';
import formatAuthRequest from './formatAuthRequest';
const getAuthorizationUrl = ({ baseURL, clientId, redirectURI, loginHintURL, scope, idTokenHint, codeVerifierPrefix }) => {
    const { oauthRedirectUri, requestBodyQueryParams } = formatAuthRequest({
        baseURL,
        clientId,
        redirectURI,
        loginHintURL,
        scope,
        idTokenHint,
        codeVerifierPrefix
    });
    return combineUrlAndParams(oauthRedirectUri, requestBodyQueryParams);
};
export default getAuthorizationUrl;
